import {Link, withRouter} from 'found';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import {Form, Message} from 'semantic-ui-react';
import styled from 'styled-components';
import {ForgotMutation} from '../mutations/ForgotMutation';

const Container = styled(Form)`
  min-height: 100vh;
  // background: #f7f7f7;
`;

const Container2 = styled.div`
  min-height: 100vh;
  // background: #f7f7f7;
`;

const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto 100px auto;
  padding: 20px;
`;

const Column = styled.div`
  margin-bottom: 20px;
  background: white;
  border: 1px solid #e5edec;
  border-radius: 5px;
`;

const Inner = styled.div`
  padding: 20px;
`;

function isValidEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len
  return re.test(email);
}

class Forgot extends React.Component {
  state = {
    email: {error: false, value: ''},
    messages: [],
    sent: false,
  };

  go = (link) => (e) => {
    e.preventDefault();
    this.props.router.push(link);
  };

  handleChange = (e, {checked, name, type, value}) => {
    if (type === 'checkbox') {
      value = checked;
    }

    if (typeof value === String) {
      value = value.trim();
    }

    //
    let error = false;
    if (name === 'email') {
      if (!isValidEmail(value)) {
        error = true;
      }
    }

    this.setState((prevState) => ({[name]: {...prevState[name], error, value}}));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {email} = this.state;

    // Validations
    let error = false;
    const errors = {
      email: {...email, error: false},
    };

    if (!isValidEmail(email.value)) {
      error = true;
      errors.email = {...email, error: true};
    }

    if (error) {
      this.setState({form: errors});
      return;
    }

    //
    const allowed = ['email'];

    //
    const payload = {
      input: {
        ...Object.keys(this.state)
          .filter((f) => allowed.indexOf(f) >= 0)
          .reduce((p, key) => ({...p, [key]: this.state[key].value}), {}),
      },
    };

    const onSuccess = (response) => {
      if (response.forgot.errors) {
        const messages = [];
        const errors = response.forgot.errors.reduce((p, c) => {
          messages.push(c.message);
          return {...p, [c.field]: {...this.state[c.field], error: true}};
        }, {});
        this.setState({messages, ...errors});
      } else {
        this.setState({sent: true});
      }
    };

    const onFailure = (response) => {
      console.log('Fail', response);
    };

    ForgotMutation(payload, onSuccess, onFailure);
  };

  renderForm() {
    const {email, messages} = this.state;

    return (
      <Container error={!isEmpty(messages)} onSubmit={this.handleSubmit}>
        <Wrapper>
          <Inner>
            <h3 style={{textAlign: 'center'}}>Enter your email for this account</h3>
          </Inner>
          <Message content={messages.join('<br />')} error header="Please fix the following problems" />
          <Column>
            <Inner>
              <p>We'll send your password to your email.</p>
              <Form.Input
                error={email.error}
                label="Email"
                name="email"
                onChange={this.handleChange}
                placeholder=""
                required
                value={email.value}
              />
              <p style={{fontSize: 14}}>
                Remember your password? <Link to="/login">Sign in</Link> with it.
              </p>
            </Inner>
          </Column>
          <div style={{padding: '20px 20px'}}>
            <Form.Button fluid primary size="large" type="submit">
              Request Password
            </Form.Button>
          </div>
        </Wrapper>
      </Container>
    );
  }

  renderSent() {
    return (
      <Container2>
        <Wrapper>
          <Inner style={{textAlign: 'center'}}>
            <h3>
              Your password has been sent <br />
              to your email.
            </h3>
            <p>
              <Link to="/login">Sign In</Link>
            </p>
          </Inner>
        </Wrapper>
      </Container2>
    );
  }

  render() {
    const {sent} = this.state;
    return sent ? this.renderSent() : this.renderForm();
  }
}

export default withRouter(Forgot);
